module.exports = __webpack_public_path__ + "img/n0.5580d138.svg";